import React, { FC } from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useTimesheetEdit } from 'src/features/timesheets/providers';
import { PermissionsEnums, TimesheetStatusEnums } from 'src/shared/enums';
import { ComponentWithPermissions } from 'src/shared/hocs';
import { useTranslate } from 'src/shared/providers';

import { TimesheetCopyLastWeek } from './TimesheetCopyLastWeek';
import { TimesheetPayPeriodWeekSelector } from './TimesheetPayPeriodWeekSelector';
import { TimesheetRefresh } from './TimesheetRefresh';
import { TimesheetStatus } from './TimesheetStatus';

export const TimesheetHeader: FC = () => {
  const { t } = useTranslate();

  const { initialTimesheet } = useTimesheetEdit();

  const isRejected = initialTimesheet?.status === TimesheetStatusEnums.REJECTED;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" alignItems="center" gap={4}>
        <TimesheetPayPeriodWeekSelector />
        <Stack direction="row" alignItems="center" gap={2}>
          <Typography fontSize="0.875rem">{t('global.status')}: </Typography>
          <TimesheetStatus status={initialTimesheet?.status} />
        </Stack>
      </Stack>
      <ComponentWithPermissions
        permissions={[PermissionsEnums.SHIFTMATCH_EDIT, PermissionsEnums.WTS_SUBMIT_TO_SUP]}
        strict
      >
        {isRejected && (
          <Alert severity="error" sx={{ width: 600 }}>
            {t('timesheets.timesheetRejectedByAdminUpdateTheTimesheetAndSubmitAgain')}
          </Alert>
        )}
      </ComponentWithPermissions>
      <Stack direction="row" alignItems="center" gap={2}>
        <TimesheetRefresh />
        <ComponentWithPermissions
          permissions={[PermissionsEnums.SHIFTMATCH_EDIT, PermissionsEnums.WTS_COPY_LAST_WEEK]}
          strict
        >
          <TimesheetCopyLastWeek />
        </ComponentWithPermissions>
      </Stack>
    </Stack>
  );
};
